import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdError, MdHome, MdArrowBack } from "react-icons/md";
import { getDefaultRoute } from "../../config/routeConfig";

const NotFound = () => {
  const navigate = useNavigate();
  const userRoles = useSelector((state) => state.user.userInfo.user_roles);

  const handleGoHome = () => {
    const defaultRoute = getDefaultRoute(userRoles);
    navigate(defaultRoute);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          py: 4,
        }}
      >
        <Card
          sx={{
            maxWidth: 600,
            width: "100%",
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Stack spacing={3} alignItems="center">
              {/* Error Icon */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  bgcolor: "error.light",
                  color: "error.contrastText",
                  mb: 2,
                }}
              >
                <MdError size={60} />
              </Box>

              {/* 404 Title */}
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "4rem", md: "6rem" },
                  fontWeight: "bold",
                  color: "primary.main",
                  lineHeight: 1,
                }}
              >
                404
              </Typography>

              {/* Error Message */}
              <Typography
                variant="h4"
                sx={{
                  color: "text.primary",
                  fontWeight: "medium",
                  mb: 1,
                }}
              >
                الصفحة غير موجودة
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  maxWidth: 400,
                  lineHeight: 1.6,
                }}
              >
                عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها إلى موقع
                آخر. يرجى التحقق من الرابط أو العودة إلى الصفحة الرئيسية.
              </Typography>

              {/* Action Buttons */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ mt: 4, width: "100%", maxWidth: 400 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<MdHome />}
                  onClick={handleGoHome}
                  sx={{
                    flex: 1,
                    py: 1.5,
                    fontSize: "1rem",
                  }}
                >
                  الصفحة الرئيسية
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  startIcon={<MdArrowBack />}
                  onClick={handleGoBack}
                  sx={{
                    flex: 1,
                    py: 1.5,
                    fontSize: "1rem",
                  }}
                >
                  العودة للخلف
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default NotFound;
